import { render } from "./AutoPMA.vue?vue&type=template&id=1fa47415"
import script from "./AutoPMA.vue?vue&type=script&lang=ts"
export * from "./AutoPMA.vue?vue&type=script&lang=ts"
script.render = render

export default script